import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full flex flex-wrap rounded-lg bg-gray-100 p-10" }
const _hoisted_2 = { class: "w-full md:w-1/2 p-2" }
const _hoisted_3 = { class: "text-3xl" }
const _hoisted_4 = { class: "w-full md:w-1/2 p-2" }
const _hoisted_5 = { class: "text-3xl" }
const _hoisted_6 = { class: "w-full flex flex-wrap" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "ml-3" }, " Ao continuar, você concorda com nossa política de Cookies e termos de tratamento de dados de acordo com a nossa política de privacidade. ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "w-full" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "ml-3",
    href: "https://moinhoglobo.com.br/politica-de-privacidade/",
    style: {"text-decoration":"underline","color":"blue"},
    target: "_blank"
  }, "https://moinhoglobo.com.br/politica-de-privacidade/")
], -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "w-full flex flex-wrap" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "ml-3" }, " Ao continuar, você concorda com nossa política de Cookies e termos de tratamento de dados de acordo com a nossa política de privacidade. ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "w-full" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "ml-3",
    href: "https://moinhoglobo.com.br/politica-de-privacidade/",
    style: {"text-decoration":"underline","color":"blue"},
    target: "_blank"
  }, "https://moinhoglobo.com.br/politica-de-privacidade/")
], -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }

import { ref, Ref, computed, onMounted } from "vue";
import store from "@/store";
import ListHeader from "@/components/ListHeader.vue";
import { novoMotorista } from "@/data/motorista";
import { Motorista } from "@/types/motorista";
import helpers from "@/helpers";
import { novaPlaca } from "@/data/placa";
import { Placa } from "@/types/placa";
import DialogModal from "@/components/Modal/DialogModal.vue";
import FormValidated from "@/components/FormValidated.vue";
import InputText from "@/components/inputs/InputText.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MotoristasPlacas',
  setup(__props) {

const modalNovoMotoristaShow = ref(false);
const modalNovoMotorista: Ref<Motorista> = ref(novoMotorista());

const modalNovaPlacaShow = ref(false);
const modalNovaPlaca: Ref<Placa> = ref(novaPlaca());

const motoristas = computed(() => store.state.motoristas);
const placas = computed(() => store.state.placas);

const isLoading = ref(false);

onMounted(async () => {
  await search();
});

const search = async () => {
  await store.dispatch("getMotoristas");
  await store.dispatch("getPlacas");
};

const onSubmitMotorista = async (values: Motorista) => {
  try {
    isLoading.value = true;
    await store.dispatch("saveMotorista", values);
    isLoading.value = false;
    helpers.mensagemSucesso(
      `Motorista ${values.razao_social} cadastrado(a) com sucesso.`
    );
    isLoading.value = false;
    modalNovoMotoristaShow.value = false;
    modalNovoMotorista.value = novoMotorista();
  } catch (err: any) {
    isLoading.value = false;
    console.log(err);
  }
};

const onSubmitPlaca = async (values: Placa) => {
  try {
    isLoading.value = true;
    await store.dispatch("savePlaca", values);
    helpers.mensagemSucesso(`Placa ${values.placa} cadastrada com sucesso.`);
    isLoading.value = false;
    modalNovaPlacaShow.value = false;
    modalNovaPlaca.value = novaPlaca();
  } catch (err: any) {
    isLoading.value = false;
    console.log(err);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_t_button = _resolveComponent("t-button")!
  const _component_t_table = _resolveComponent("t-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(ListHeader, {
          label: "",
          class: "w-full"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_font_awesome_icon, { icon: "users" }),
              _createTextVNode(" Motoristas "),
              _createVNode(_component_t_button, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (
              (modalNovoMotorista.value = _unref(novoMotorista)()),
                (modalNovoMotoristaShow.value = true)
            ))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Novo motorista")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        (_unref(motoristas))
          ? (_openBlock(), _createBlock(_component_t_table, {
              key: 0,
              actions: true,
              value: _unref(motoristas),
              header: {
          cpf_cnpj: 'CPF',
          razao_social: 'Nome',
          celular: 'Celular',
          data_cadastro: 'Data Cadastro',
        }
            }, {
              data_cadastro: _withCtx(({ $item: item }) => [
                _createTextVNode(_toDisplayString(_unref(helpers).formatDataByLocation(item.data_cadastro)), 1)
              ]),
              _: 1
            }, 8, ["value"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(ListHeader, {
          label: "",
          class: "w-full"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_font_awesome_icon, { icon: "list" }),
              _createTextVNode(" Placas "),
              _createVNode(_component_t_button, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ((modalNovaPlaca.value = _unref(novaPlaca)()), (modalNovaPlacaShow.value = true)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Nova placa")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        (_unref(placas))
          ? (_openBlock(), _createBlock(_component_t_table, {
              key: 0,
              actions: true,
              value: _unref(placas),
              header: {
          placa: 'Placa',
        }
            }, null, 8, ["value"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(DialogModal, {
      show: modalNovoMotoristaShow.value,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (modalNovoMotoristaShow.value = false))
    }, {
      title: _withCtx(() => [
        _createVNode(ListHeader, { label: "Novo Motorista" })
      ]),
      content: _withCtx(() => [
        (modalNovoMotoristaShow.value)
          ? (_openBlock(), _createBlock(FormValidated, {
              key: 0,
              "initial-values": modalNovoMotorista.value,
              "hide-buttons": true,
              onSave: onSubmitMotorista,
              validation: {
          cpf_cnpj: 'required|min:11',
          razao_social: 'required',
          celular: 'required|min:10',
        }
            }, {
              form: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(InputText, {
                    name: "cpf_cnpj",
                    tclass: "md:w-full",
                    label: "CPF"
                  }),
                  _createVNode(InputText, {
                    name: "razao_social",
                    tclass: "md:w-full",
                    label: "Nome"
                  }),
                  _createVNode(InputText, {
                    name: "celular",
                    tclass: "md:w-full",
                    label: "Celular",
                    mascara: "(99)99999-9999"
                  }),
                  _hoisted_7,
                  _hoisted_8,
                  _hoisted_9,
                  _createVNode(_component_t_button, {
                    class: "ml-3",
                    type: "submit"
                  }, {
                    default: _withCtx(() => [
                      (isLoading.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "sync-alt",
                              spin: ""
                            }),
                            _createTextVNode(" Salvando...")
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_11, "Salvar Motorista"))
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["initial-values"]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_t_button, {
          color: "gray",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (modalNovoMotoristaShow.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Fechar")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(DialogModal, {
      show: modalNovaPlacaShow.value,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (modalNovaPlacaShow.value = false))
    }, {
      title: _withCtx(() => [
        _createVNode(ListHeader, { label: "Nova Placa" })
      ]),
      content: _withCtx(() => [
        (modalNovaPlacaShow.value)
          ? (_openBlock(), _createBlock(FormValidated, {
              key: 0,
              "initial-values": modalNovaPlaca.value,
              "hide-buttons": true,
              onSave: onSubmitPlaca,
              validation: {
          placa: 'required',
        }
            }, {
              form: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(InputText, {
                    maxlength: "7",
                    name: "placa",
                    tclass: "md:w-full",
                    label: "Placa"
                  }),
                  _hoisted_13,
                  _hoisted_14,
                  _hoisted_15,
                  _createVNode(_component_t_button, {
                    class: "ml-3",
                    type: "submit"
                  }, {
                    default: _withCtx(() => [
                      (isLoading.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "sync-alt",
                              spin: ""
                            }),
                            _createTextVNode(" Salvando...")
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_17, "Salvar Placa"))
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["initial-values"]))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_t_button, {
          color: "gray",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (modalNovaPlacaShow.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Fechar")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})